import { render } from "./UserQuestionnaireList.vue?vue&type=template&id=e1d205ca&scoped=true&ts=true"
import script from "./UserQuestionnaireList.vue?vue&type=script&lang=ts"
export * from "./UserQuestionnaireList.vue?vue&type=script&lang=ts"

import "./UserQuestionnaireList.vue?vue&type=style&index=0&id=e1d205ca&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d205ca"]])

export default __exports__